/* tslint:disable */
/* eslint-disable */
/**
 * UPSIDER Core IAM API Specifications
 * Contains specifications for Core IAM, defining only the specifications for the REST API and not including specifications for GraphQL, gRPC, etc.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export * from './api/default-api';

